export default {
  goodOrders(state) {
    return state.goodOrders
  },
  goodOrderFilters(state) {
    return state.goodOrderFilters
  },
  goodOrderStatuses(state) {
    return state.goodOrderStatuses
  },
  goodOrder(state) {
    return state.goodOrder
  },
  goodOrderItems(state) {
    return state.goodOrderItems
  },
  goodOrderProducts(state) {
    return state.goodOrderProducts
  },
  syncItems(state) {
    return state.syncItems
  },
}
